module.exports = __webpack_public_path__ + "media/images/handshakebg-bbebbe42e98e95ac2148d189c74d9dc5.jpg";